import { Injectable } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { RestService, SessionStorageService } from '@tdwb/core';
import { Checklist } from './checklist.domain';

@Injectable()
export class ChecklistRestService {

  private static readonly COACHMARK_CHECKLIST_KEY: string = 'coachmark_checklist';

  constructor(private restService: RestService, private storageService: SessionStorageService) {
  }

  getChecklist(): Observable<Checklist> {
    const coachmarkChecklistFromSession = this.getChecklistFromSession();
    if(coachmarkChecklistFromSession) {
      return of(coachmarkChecklistFromSession);
    }
    return this.restService.getResource('checklist.getChecklist').get<Checklist>().pipe(
      tap((response: Checklist) => this.storeChecklistToSession(response)),
      catchError(() => of({
        fractionalCoachMarkDisplayed: true,
        nonFractionalCoachMarkDisplayed: true,
        dripsTabCoachmarkDisplayed: true,
        dripsEligibilityCoachmarkDisplayed: true
      } as Checklist))
    );
  }

  updateCoachmarkChecklist(params: Checklist): Observable<unknown> {
    return this.restService.getResource('checklist.updateChecklist').patch(params).pipe(
      tap(() => this.storeChecklistToSession(params))
    );
  }

  getChecklistFromSession(): Checklist | null {
    return this.storageService.getItem(ChecklistRestService.COACHMARK_CHECKLIST_KEY);
  }

  storeChecklistToSession(response: Checklist): void {
    this.storageService.setItem(ChecklistRestService.COACHMARK_CHECKLIST_KEY, response);
  }

}

